export enum HitsAlertSteps {
  First = 10,
  Second = 25,
  Third = 50,
  Fourth = 100,
  Fifth = 200,
  Sixth = 300
}
